var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-col",
    { attrs: { cols: "auto" } },
    [
      _c(
        "v-avatar",
        {
          staticStyle: { "z-index": "1", "margin-right": "-60px!important" },
          attrs: { size: "50px", left: "", color: "teal darken-3" }
        },
        [
          _c("v-icon", { attrs: { color: "white", large: "" } }, [
            _vm._v("cci-rank-2")
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-chip",
        {
          staticClass: "mx-2 my-1 font-weight-bold",
          attrs: { large: "", pill: "", color: "teal accent-4" }
        },
        [
          _c("span", { staticClass: "pl-10 pr-2 body-text black--text" }, [
            _vm._v(" " + _vm._s(_vm.name))
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }